<template>
  <router-view />
</template>

<script>
export default {
  name: 'WrapperHelpDesk',
  data() {
    return {
      moduleName: 'HelpDeskModule',
    };
  },
};
</script>
